import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { CONCURSOAPI, USERAPI } from '../../../const';

//
// ─── GETTER THUNKS ─────────────────────────────────────────────────────────────────────
//

export const fetchEnProgreso = createAsyncThunk(
  'global/concurso/gestion/fetchEnProgreso',
  async (args, thunkAPI) => {
    let query = new URLSearchParams(args?.filtros).toString();

    if (query) query = `?${query}`;

    const req = await axios.get(`${CONCURSOAPI}/llamadoconcurso${query}`);
    return req.data;
  },
);
export const fetchConcursoActivo = createAsyncThunk(
  'global/concurso/gestion/fetchConcursoActivo',
  async (args, thunkAPI) => {
    const req = await axios.get(`${CONCURSOAPI}/llamadoconcurso/${args?.idConcurso}`);
    return req.data;
  },
);

export const fetchRolComite = createAsyncThunk(
  'global/concurso/fetchRolComite',
  async (args, thunkAPI) => {
    //let data = JSON.parse(localStorage.getItem("rolComite"));
    let data = null;
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/rolcomite`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idRolComite]: cur };
      }, {});
      localStorage.setItem('rolComite', JSON.stringify(data));
    }

    return data;
  },
);
export const fetchRolComitePublico = createAsyncThunk(
  'global/concurso/fetchRolComitePublico',
  async (args, thunkAPI) => {
    //let data = JSON.parse(localStorage.getItem("rolComite"));
    let data = null;
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/concursos-publicados/rol-comite`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idRolComite]: cur };
      }, {});
      localStorage.setItem('rolComitePublico', JSON.stringify(data));
    }

    return data;
  },
);
export const fetchRolComiteParaLegales = createAsyncThunk(
  'global/concurso/fetchRolComiteParaLegales',
  async (args, thunkAPI) => {
    let data = JSON.parse(localStorage.getItem('rolComiteParaLegales'));
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/rolcomite/legales`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idRolComite]: cur };
      }, {});
      localStorage.setItem('rolComiteParaLegales', JSON.stringify(data));
    }

    return data;
  },
);

export const fetchRolComiteParaDirector = createAsyncThunk(
  'global/concurso/fetchRolComiteParaDirector',
  async (args, thunkAPI) => {
    let data = JSON.parse(localStorage.getItem('rolComiteParaDirector'));
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/rolcomite/director`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idRolComite]: cur };
      }, {});
      localStorage.setItem('rolComiteParaDirector', JSON.stringify(data));
    }

    return data;
  },
);

export const fetchRepresentacionesVeedor = createAsyncThunk(
  'global/concurso/fetchRepresentacionesVeedor',
  async (args, thunkAPI) => {
    //let data = JSON.parse(localStorage.getItem("representacionesVeedores"));
    let data = null;
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/rolcomite/director`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idRolComite]: cur };
      }, {});
      localStorage.setItem('representacionesVeedores', JSON.stringify(data));
    }

    return data;
  },
);

export const fetchTiposConcurso = createAsyncThunk(
  'global/concurso/fetchTiposConcurso',
  async (args, thunkAPI) => {
    let data = JSON.parse(localStorage.getItem('tiposConcurso'));
    if (data == null) {
      const req = await axios.get(`${CONCURSOAPI}/tipoconcurso/`);
      data = req.data.reduce((acum, cur) => {
        return { ...acum, [cur.idTipoConcurso]: cur };
      }, {});
      localStorage.setItem('tiposConcurso', JSON.stringify(data));
    }

    return data;
  },
);

export const fetchJurisdiccion = createAsyncThunk(
  'global/concurso/fetchJurisdiccion',
  async (args, { getState }) => {
    const loadedJurisdiccion = getState().gestionConcurso.jurisdicciones;
    const loadedOrganismos = getState().gestionConcurso.organismos;

    if (Object.keys(loadedJurisdiccion).length > 0)
      return {
        jurisdicciones: loadedJurisdiccion,
        organismos: loadedOrganismos,
      };

    const req = await axios.get(`${CONCURSOAPI}/jurisdiccion/`).catch((error) => {
      throw error;
    });

    const juris = req.data;

    juris.sort((a, b) => {
      return a.nombre < b.nombre ? -1 : 1;
    });

    const orga = juris.reduce((acum, cur) => {
      cur.organismos.forEach((el) => {
        acum[el.idOrganismo] = el;
      });
      return acum;
    }, []);

    return {
      jurisdicciones: juris,
      organismos: orga,
    };
  },
);

export const fetchJurisdiccionPublico = createAsyncThunk(
  'global/concurso/fetchJurisdiccionPublico',
  async (args, { getState }) => {
    const loadedJurisdiccion = getState().gestionConcurso.jurisdicciones;
    const loadedOrganismos = getState().gestionConcurso.organismos;

    if (Object.keys(loadedJurisdiccion).length > 0)
      return {
        jurisdicciones: loadedJurisdiccion,
        organismos: loadedOrganismos,
      };

    const req = await axios
      .get(`${CONCURSOAPI}/concursos-publicados/jurisdicciones`)
      .catch((error) => {
        throw error;
      });

    const juris = req.data;

    juris.sort((a, b) => {
      return a.nombre < b.nombre ? -1 : 1;
    });

    const orga = juris.reduce((acum, cur) => {
      cur.organismos.forEach((el) => {
        acum[el.idOrganismo] = el;
      });
      return acum;
    }, []);

    return {
      jurisdicciones: juris,
      organismos: orga,
    };
  },
);

//
// ─── SETTER THUNKS ─────────────────────────────────────────────────────────────────────
//

export const crearNuevoConcurso = createAsyncThunk(
  'globalsemi/concurso/gestion/createConcurso',
  async (args, thunkAPI) => {
    const data = new FormData();
    data.append('documentoProda', args.data.documentoProda);
    data.append('documentoDenominacionPuesto', args.data.documentoDenominacionPuesto);
    data.append(
      'datos',
      JSON.stringify({
        activo: true,
        publicado: false,
        ...args.data.datos,
      }),
    );
    const req = await axios.post(`${CONCURSOAPI}/llamadoconcurso`, data).catch((error) => {
      throw error;
    });
    return req.data;
  },
);

export const asignarComite = createAsyncThunk(
  'globalsemi/concurso/gestion/asignarComite',
  async (args, thunkAPI) => {
    const req = await axios.post(`${CONCURSOAPI}/llamadoconcurso/asignacioncomite`, {});
    return req.data;
  },
);
export const verCVComite = createAsyncThunk(
  'globalsemi/concurso/gestion/verCVComite',
  async (args, thunkAPI) => {
    //var fileDownload = require("js-file-download");
    const req = await axios
      .get(`${USERAPI}/usuarios/file/${args.idUsuario}`, {
        responseType: 'blob',
      })
      .catch((error) => {
        alert('Error: No es posible recuperar el archivo deseado!!');
      });
    const file = new Blob([req.data], { type: 'application/pdf' });
    window.open(URL.createObjectURL(file));
    /* window.open(
      URL.createObjectURL(
        fileDownload(
          req.data,
          `CV_${args.nombre}_${args.apellido}_${args.cuil}.pdf`
        )
      )
    ); */

    return true;
  },
);
export const verPerfilPuesto = createAsyncThunk(
  'globalsemi/concurso/gestion/verPerfilPuesto',
  async (args, thunkAPI) => {
    //var fileDownload = require("js-file-download");
    const req = await axios
      .get(`${CONCURSOAPI}/puesto/file/perfil/${args.idPuesto}`, {
        responseType: 'blob',
      })
      .catch((error) => {
        alert('Error: No es posible recuperar el archivo de perfill!!');
      });
    const file = new Blob([req.data], { type: 'application/pdf' });
    window.open(URL.createObjectURL(file));

    return true;
  },
);

export const verBasePuesto = createAsyncThunk(
  'globalsemi/concurso/gestion/verBasePuesto',
  async (args, thunkAPI) => {
    //var fileDownload = require("js-file-download");
    const req = await axios
      .get(`${CONCURSOAPI}/puesto/file/bbycc/${args.idPuesto}`, {
        responseType: 'blob',
      })
      .catch((error) => {
        alert('Error: No es posible recuperar el archivo de bases y condiciones.');
      });
    const file = new Blob([req.data], { type: 'application/pdf' });
    window.open(URL.createObjectURL(file));

    return true;
  },
);

export const verPerfilPublicoPuesto = createAsyncThunk(
  'globalsemi/concurso/gestion/verPerfilPublicoPuesto',
  async (args, thunkAPI) => {
    //var fileDownload = require("js-file-download");
    const req = await axios
      .get(`${CONCURSOAPI}/concursos-publicados/file/perfil-puesto/${args.idPuesto}`, {
        responseType: 'blob',
      })
      .catch((error) => {
        alert('Error: No es posible recuperar el archivo de perfill!!');
      });
    const file = new Blob([req.data], { type: 'application/pdf' });
    window.open(URL.createObjectURL(file));
    return true;
  },
);

//
// ─── SLICE ──────────────────────────────────────────────────────────────────────
//

export const gestionConcursoSlice = createSlice({
  name: 'gestionConcurso',
  initialState: {
    enProgreso: [],
    tiposConcurso: [],
    activo: {},
    jurisdicciones: [],
    jurisdiccionesPublicas: [],
    organismos: [], //separado de jurisdiccion para cuando hay referencias directas a idOrganismo
    organismosPublicos: [],
    rolComite: [],
    rolComitePublico: [],
    rolComiteParaLegales: [],
    rolComiteParaDirector: [],
    representacionesVeedores: [],
  },
  reducers: {
    finEtapa: (state) => {
      return {
        ...state,
        enProgreso: [],
        activo: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJurisdiccion.fulfilled, (state, action) => {
        state.jurisdicciones = action.payload.jurisdicciones;
        state.organismos = action.payload.organismos;
      })
      .addCase(fetchJurisdiccionPublico.fulfilled, (state, action) => {
        state.jurisdiccionesPublicas = action.payload.jurisdicciones;
        state.organismosPublicos = action.payload.organismos;
      })
      .addCase(fetchRolComite.fulfilled, (state, action) => {
        state.rolComite = action.payload;
      })
      .addCase(fetchRolComitePublico.fulfilled, (state, action) => {
        state.rolComitePublico = action.payload;
      })
      .addCase(fetchRolComiteParaLegales.fulfilled, (state, action) => {
        state.rolComiteParaLegales = action.payload;
      })
      .addCase(fetchRolComiteParaDirector.fulfilled, (state, action) => {
        state.rolComiteParaDirector = action.payload;
      })
      .addCase(fetchRepresentacionesVeedor.fulfilled, (state, action) => {
        state.representacionesVeedores = action.payload;
      })
      .addCase(fetchEnProgreso.fulfilled, (state, action) => {
        action.payload.sort((a, b) =>
          a.idEtapaLlamadoConcurso > b.idEtapaLlamadoConcurso ? -1 : 1,
        );
        state.enProgreso = action.payload;
      })
      .addCase(fetchTiposConcurso.fulfilled, (state, action) => {
        state.tiposConcurso = action.payload;
      })
      .addCase(fetchConcursoActivo.pending, (state, action) => {
        state.activo = null;
      })
      .addCase(fetchConcursoActivo.rejected, (state, action) => {
        state.activo = {};
      })
      .addCase(fetchConcursoActivo.fulfilled, (state, action) => {
        state.activo = action.payload;
      });
  },
});

export const enProgresoSelector = (state) => state.gestionConcurso.enProgreso;
export const activoSelector = (state) => state.gestionConcurso.activo;
export const jurisSelector = (state) => state.gestionConcurso.jurisdicciones;
export const jurisPublicoSelector = (state) => state.gestionConcurso.jurisdiccionesPublicas;
export const orgaSelector = (state) => state.gestionConcurso.organismos;
export const orgaPublicoSelector = (state) => state.gestionConcurso.organismosPublicos;
export const rolComiteSelector = (state) => state.gestionConcurso.rolComite;
export const rolComitePublicoSelector = (state) => state.gestionConcurso.rolComitePublico;
export const rolComiteLegalesSelector = (state) => state.gestionConcurso.rolComite;
export const rolComiteDirectorSelector = (state) => state.gestionConcurso.rolComite;
export const tiposSelector = (state) => state.gestionConcurso.tiposConcurso;
export const representacionesVeedoresSelector = (state) =>
  state.gestionConcurso.representacionesVeedores;
export const { finEtapa } = gestionConcursoSlice.actions;
export default gestionConcursoSlice.reducer;
